<template>
    <search-input
        :placeholder="filter.text"
        :name="fKey"
        :search-input="filter.value"
        :tooltip="filter.tooltip"
        :search-params-tooltip="filter.searchParamsTooltip"
        :inactive="filter.inactive"
        @change="$emit('set-filter', $event)"
        @keyup.native.enter="$emit('apply-filters')"
    />
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>